<template>
  <div class="container">
    <div class="table_box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="登录日志" name="1"></el-tab-pane>
        <el-tab-pane label="操作日志" name="2"></el-tab-pane>
      </el-tabs>
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="logUser" label="登录账号"> </el-table-column>
        <el-table-column property="userName" label="姓名"> </el-table-column>
        <el-table-column property="roleList" label="角色"> </el-table-column>
        <el-table-column property="logIp" label="登录IP地址"> </el-table-column>
        <el-table-column property="operTime" label="登录时间">
        </el-table-column>
        <el-table-column property="operAddress" label="登录地点">
        </el-table-column>
        <el-table-column property="logResult" label="操作记录" v-if="handleIndex == '1'">
        </el-table-column>
      </el-table>

      <div class="paging_box">
        <!--  :current-page="currentPage4" -->
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      tableData: [],
      tableParams: {
        page: 1,
        limit: 10,
        startTime: "",
        endTime: "",
        logUser: "",
        operateType: "用户登录",
        operParam: "",
        content: "", // 日志内容模糊查询
      },
      total: 0,
      tableLoading: false,
      stateList: [],
      activeName: "1",
      handleIndex: "0",
    };
  },
  components: {},
  props: {},
  created () {
    this.getList();
  },
  methods: {
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    addData () {
      this.addShow = true;
    },
    getList () {
      this.tableLoading = true;
      this.$http.queryLogList(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.msg);
        }
      });
    },
    handleClick (e) {
      if (this.handleIndex == e.index) {
        return false;
      } else {
        this.tableParams.page = 1;
        this.tableParams.limit = 10;
        this.handleIndex = e.index;
        if (this.handleIndex == "0") {
          this.tableParams.operateType = "用户登录";
        } else {
          this.tableParams.operateType = "";
        }
        this.getList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/log_Admin/log_Admin.vue